import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

import { useDepartmentsBar } from './department-bar-hooks';
import { DepartmentStyles as styles } from './styles';
import DepartmentMegaMenu from './department-mega-menu/department-mega-menu';
import DepartmentDrawerMenu from './department-drawer/department-drawer-menu';
import { useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import SessionStorageManager from 'utils/session-storage-manager';
import { zIndex } from 'constants/zIndex';
import { welcomeBarDataSelector } from 'redux/selectors';
import isEmpty from 'lodash/isEmpty';
import { responsiveBreakpoints } from 'utils/utils';

const DepartmentsBar = () => {
  const {
    departments,
    departmentsLoading,
    handleOpenMegaMenu,
    handleCloseMegaMenu,
    handleOpenMoreMenu,
    handleCloseMoreMenu,
    openMegaMenu,
    openMoreMenu,
    selectedDepartment,
    customerDetail,
    handleShopByLookBookClick,
    handleDepartmentClick,
    menuButtonXPosition,
    timeoutId,
    setTimeoutId,
    departmentContainerWidth,
  } = useDepartmentsBar();
  const welcomeBarConfig = useSelector(welcomeBarDataSelector);
  const { theme, mobile, tablet, laptop, desktop, mainWidth } =
    responsiveBreakpoints();

  const [searchParams] = useSearchParams();
  let myRef = useRef();
  return (
    <Box
      sx={{
        height: '40px',
        maxHeight: '50px',
        backgroundColor: 'var(--paper-background-color)',
        boxShadow: 0,
        borderTop: '1px solid rgba(204, 204, 204, 0.6)',
        borderBottom: '1px solid rgba(204, 204, 204, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        position: 'sticky',
        // top: '111px',
        // top: `${
        //   !isEmpty(welcomeBarConfig) && welcomeBarConfig.wel_bar_pos == 1
        //     ? `${parseInt(welcomeBarConfig.bar_height) + 111}px`
        //     : '111px'
        // }`,
        top: `${
          !isEmpty(welcomeBarConfig) && welcomeBarConfig.wel_bar_pos == 1
            ? `${parseInt(welcomeBarConfig.bar_height) + 31}px`
            : '31px'
        }`,
        zIndex: zIndex.stickyH3,
      }}
      onMouseLeave={() => {
        clearTimeout(timeoutId);
        setTimeoutId(clearTimeout(timeoutId));
        if (openMegaMenu) handleCloseMegaMenu();
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          width: mainWidth,
        }}
      >
        <Stack
          className='header2-container'
          direction='row'
          sx={{
            height: '100%',
            width: `${customerDetail?.shopByLookBook ? '80%' : '95%'}`,
          }}
        >
          <Box
            className='department-list-box-container'
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '35px',
              width: `${departmentContainerWidth}px`,
              // width: 'fit-conent',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {!departmentsLoading ? (
              departments &&
              departments.map((department, index) => {
                if (index == 0) {
                  SessionStorageManager.setSessionStorage(
                    'firstCollectionId',
                    department.collectionId
                  );

                  SessionStorageManager.setSessionStorage(
                    'firstDepartmentId',
                    department.genderId
                  );
                }

                return (
                  <Stack
                    className='child-element'
                    key={department?.genderId}
                    id={department?.genderId}
                    direction='row'
                    spacing={1}
                    // variant='text'
                    ref={myRef}
                    sx={[
                      styles.departmentBtn,
                      selectedDepartment?.genderId == department?.genderId
                        ? styles.selectedDepartmentBtn
                        : null,
                      searchParams.get('gndr') == department?.genderId
                        ? {
                            color: 'var(--theme-color)',
                            borderColor: 'var(--theme-color)',
                          }
                        : null,
                    ]}
                    onMouseEnter={(e) => {
                      setTimeoutId(
                        setTimeout(() => {
                          const elem = e.target;
                          const rect = elem.getBoundingClientRect();
                          const scrollTop = document.documentElement.offsetLeft;
                          const viewWidth = window.innerWidth; // get the width of the browser
                          let overFlowWidhtPx = 0;
                          if (rect.left + 700 >= viewWidth) {
                            // check if megamenu width of 700px exceeds the width of browser
                            // megamenu width = 700
                            // rect.left = this is the position of the menu button on the browser
                            //rect.left + 700 >= viewWidth = this is to check if megamenu exceeds the browser width
                            overFlowWidhtPx = rect.left + 700 - viewWidth; // checks how many px exceeds the browser and assigns it to overflowWIdthPx
                          }
                          const menuButtonXPosition =
                            scrollTop + rect.left - overFlowWidhtPx;

                          handleOpenMegaMenu(
                            { ...department, index },
                            menuButtonXPosition
                          );
                        }, 500)
                      );
                    }}
                    onMouseLeave={() => {}}
                    onClick={() => handleDepartmentClick(department)}
                  >
                    {department?.logo_file && (
                      <img
                        src={department?.logo_file}
                        style={styles.departmentImg}
                      />
                    )}
                    {department?.genderName}
                  </Stack>
                );
              })
            ) : (
              <Box display='flex' gap={2}>
                <CircularProgress size={25} />
              </Box>
            )}
          </Box>
          <Button
            id='and-more'
            variant='text'
            sx={{
              display: 'none',
              whiteSpace: 'nowrap',

              height: '100%',
            }}
            onClick={() => handleOpenMoreMenu()}
          >
            & MORE...
          </Button>
        </Stack>
        {/* shopbylookbooks and search */}
        <Stack
          direction='row'
          sx={{
            height: '100%',
            justifyContent: 'right',
            alignItems: 'center',
            width: `${customerDetail?.shopByLookBook ? '20%' : '5%'}`,
          }}
        >
          {customerDetail?.shopByLookBook && (
            <Button
              variant='outlined'
              size='small'
              sx={styles.lookBooksButton}
              onClick={handleShopByLookBookClick}
            >
              SHOP BY LOOKBOOKS
            </Button>
          )}
        </Stack>
      </Box>

      {/* <AppBar
        position='static'
        sx={styles.appBar}
        onMouseLeave={() => {
          clearTimeout(timeoutId);
          if (openMegaMenu) handleCloseMegaMenu();
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            [theme.breakpoints.up('xs')]: { margin: '0 10px 0 10px' },
            [theme.breakpoints.up('md')]: { margin: '0 0 0 0' },
            [theme.breakpoints.up('lg')]: { margin: '0 74px 0 74px' },
          }}
        ></Toolbar>
        {openMegaMenu && (
          <DepartmentMegaMenu
            selectedDepartment={selectedDepartment}
            handleCloseMenus={handleCloseMegaMenu}
            menuButtonXPosition={menuButtonXPosition}
            open={openMegaMenu}
          />
        )}
      </AppBar> */}
      {openMegaMenu && (
        <DepartmentMegaMenu
          selectedDepartment={selectedDepartment}
          handleCloseMenus={handleCloseMegaMenu}
          menuButtonXPosition={menuButtonXPosition}
          open={openMegaMenu}
        />
      )}
      {openMoreMenu && (
        <DepartmentDrawerMenu
          departments={departments}
          departmentsLoading={departmentsLoading}
          handleCloseMenus={handleCloseMoreMenu}
          handleDepartmentClick={handleDepartmentClick}
        />
      )}
    </Box>
  );
};

DepartmentsBar.propTypes = {};

export default DepartmentsBar;
